import { VariantProps, cva } from "class-variance-authority"
import { DetailedHTMLProps, HTMLAttributes, ReactNode, forwardRef, useId } from "react"
import { cn } from "../../lib/utils"

const pageCardSectionVariants = cva("justify-left flex min-h-11.25 w-auto flex-row text-menu", {
	variants: {
		variant: {
			header: "mb-3 border-b-1 pb-3 border-dipai-text-disabled",
			headerSimple: "",
			footer: "mt-3 border-t-1 pt-3",
		},
	},
})

export interface IPageCardSectionProps
	extends
		DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
		VariantProps<typeof pageCardSectionVariants> {
	label?: ReactNode
}

const PageCardSection = forwardRef<HTMLDivElement, IPageCardSectionProps>((props, ref) => {
	const { label, className, children, variant, id, ...rest } = props
	const generatedId = useId()
	const labelId = label !== undefined && label !== "" ? (id ?? `${generatedId}-label`) : undefined

	return (
		<div
			ref={ref}
			id={id}
			aria-labelledby={labelId}
			className={cn(pageCardSectionVariants({ variant, className }))}
			{...rest}
		>
			{label !== undefined ? (
				<span
					className={`text-dipai-text-primary mr-8 min-w-fit content-center font-semibold`}
					id={labelId}
				>
					{label}
				</span>
			) : null}
			{children !== undefined &&
			(Array.isArray(children) === true ? children.some((c) => c !== null) : true) ? (
				<div className={`flex w-full flex-row justify-between`}>{children}</div>
			) : null}
		</div>
	)
})

export { PageCardSection, pageCardSectionVariants }
